module.exports = __webpack_public_path__ + "static/media/poi-logo-icon.6a5e3458.svg";